module.exports = __webpack_public_path__ + "img/background-login.15a75723.jpg";